import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const ModalDialog = () => {
  const [openBasic, setOpenBasic] = useState(false);
  const [openAdvanced, setOpenAdvanced] = useState(false);

  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* BASIC MODALS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Modal Dialogs</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Basic Modal</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600 h-32 flex flex-col items-center justify-center">
              <button onClick={() => setOpenBasic(true)} className="px-3 py-1 bg-amber-600 text-white rounded text-sm">Open Modal</button>
              {openBasic && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => setOpenBasic(false)}><div className="bg-slate-800 border border-slate-600 rounded p-4 max-w-xs" onClick={e => e.stopPropagation()}><h4 className="font-semibold text-slate-100 mb-2">Confirm Action</h4><p className="text-sm text-slate-400 mb-4">Are you sure?</p><div className="flex gap-2"><button onClick={() => setOpenBasic(false)} className="flex-1 px-3 py-1 bg-slate-700 text-slate-100 rounded text-sm">Cancel</button><button onClick={() => setOpenBasic(false)} className="flex-1 px-3 py-1 bg-amber-600 text-white rounded text-sm">OK</button></div></div></div>}
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`const [open, setOpen] = useState(false);

return (
  <>
    <button onClick={() => setOpen(true)}>Open</button>
    {open && <div className="fixed inset-0 bg-black/50 flex items-center justify-center">
      <div className="bg-slate-800 rounded p-4">
        <p className="text-slate-300 mb-4">Confirm?</p>
        <button onClick={() => setOpen(false)}>OK</button>
      </div>
    </div>}
  </>
);`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Centered Modal</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600 h-32 flex items-center justify-center">
              <div className="text-center text-slate-400 text-xs">Modal preview</div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="fixed inset-0 bg-black/50 flex items-center justify-center">
  <div className="bg-slate-800 border border-slate-600 rounded p-4 max-w-sm">
    <h3 className="text-slate-100 font-bold mb-2">Title</h3>
    <p className="text-slate-400 text-sm mb-4">Content</p>
    <button className="bg-amber-600 text-white px-4 py-2 rounded">Action</button>
  </div>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Alert Modal</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600 h-32 flex items-center justify-center">
              <div className="text-center"><div className="text-4xl mb-2">??</div><p className="text-slate-400 text-xs">Alert message</p></div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="bg-yellow-900 border border-yellow-600 rounded p-4">
  <div className="text-4xl mb-2">??</div>
  <p className="text-yellow-100">Alert message</p>
  <button className="mt-3 bg-yellow-600">Acknowledge</button>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Success Modal</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600 h-32 flex items-center justify-center">
              <div className="text-center"><div className="text-4xl mb-2">?</div><p className="text-slate-400 text-xs">Success!</p></div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="bg-green-900 border border-green-600 rounded p-4 text-center">
  <div className="text-4xl mb-2">?</div>
  <p className="text-green-100 font-medium">Success!</p>
</div>`} />
          </div>
        </div>
      </div>

      {/* ADVANCED MODALS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Advanced Variants</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Form Modal</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600 h-32 space-y-2">
              <input type="text" placeholder="Name" className="w-full px-2 py-1 bg-slate-800 border border-slate-600 rounded text-xs text-slate-300" />
              <input type="email" placeholder="Email" className="w-full px-2 py-1 bg-slate-800 border border-slate-600 rounded text-xs text-slate-300" />
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="bg-slate-800 rounded p-4 space-y-3">
  <input type="text" placeholder="Name" className="w-full px-2 py-1 bg-slate-900 border border-slate-600" />
  <input type="email" placeholder="Email" className="w-full px-2 py-1 bg-slate-900 border border-slate-600" />
  <button className="w-full bg-amber-600 text-white py-2 rounded">Submit</button>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Confirmation Steps</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600 h-32 space-y-2">
              <div className="flex gap-2">{[1, 2, 3].map(i => <div key={i} className="flex-1 h-2 bg-slate-700 rounded" />)}</div>
              <p className="text-xs text-slate-400">Step 2 of 3</p>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="space-y-3">
  <div className="flex gap-2">
    {[1, 2, 3].map(i => (
      <div key={i} className="flex-1 h-2 bg-slate-700" />
    ))}
  </div>
  <p className="text-slate-400 text-sm">Step 2 of 3</p>
</div>`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalDialog;


